import React from "react";
import styles from "./toolbar.module.scss";
import { MdOutlineAdd } from "react-icons/md";
import classNames from "classnames";
import { BiRefresh } from "react-icons/bi";
import ToolBtn from "@/features/bridge/components/token-selector/selector-interface/tool-btn";
import { motion } from "framer-motion";
import { useTokenFilterStore } from "@/features/bridge/stores/token-filter.store";
import BlessSwitch from "@/components/layout/switch";

type Props = {
  refetchTokens: () => void;
  selectAllTokens?: () => void;
  selectionCount?: number;
  showClearBtn?: boolean;
  onClear?: () => void;
  isEnabled?: boolean;
};

const Toolbar = ({
  selectAllTokens,
  refetchTokens,
  selectionCount,
  isEnabled,
  showClearBtn,
  onClear,
}: Props) => {
      const { showOnlyBridgeableTokens, setShowOnlyBridgeableTokens } = useTokenFilterStore();

    return (
    <div className={styles.toolbar}>
      <div className={styles.buttons}>
        <ToolBtn onClick={refetchTokens}>
          <BiRefresh size={20} /> Refresh List
        </ToolBtn>

        {showClearBtn && <ToolBtn onClick={onClear!}>Clear selection</ToolBtn>}
        {isEnabled && (
          <>
            {selectAllTokens && (
              <ToolBtn onClick={selectAllTokens}>
                <MdOutlineAdd size={20} /> Select All
              </ToolBtn>
            )}
          </>
        )}
      </div>

      <div className={styles.rightSection}>
        {!!selectionCount && (
          <motion.div
            initial={{ translateX: -10, opacity: 0 }}
            animate={{ translateX: 0, opacity: 1 }}
            className={styles.selectedCount}
          >
            <b className={classNames(selectionCount && styles.active)}>
              {selectionCount}
            </b>
            tokens selected
          </motion.div>
        )}

        <div className={styles.switchWrapper}>
          <BlessSwitch
            left="All Tokens"
            right="Bridgeable Only"
            status={showOnlyBridgeableTokens}
            onStatusSwitch={setShowOnlyBridgeableTokens}
          />
        </div>
      </div>
    </div>
  );
};

export default Toolbar;
